import script from "./TheoryQs.vue?vue&type=script&setup=true&lang=js"
export * from "./TheoryQs.vue?vue&type=script&setup=true&lang=js"

import "./TheoryQs.vue?vue&type=style&index=0&id=5c5a06be&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5a06be"]])

export default __exports__